export const UPLOAD_STATUSES = [
  'created',
  'in_process',
  'in_validation',
  'error',
  'done',
] as const;
